import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'
import moment from 'moment'
import { FormattedMessage } from 'react-intl'
import { compose } from 'recompose'
import queryString from 'query-string'

import { wizard } from 'helpers/decorators'
import { ConfigurationFile } from 'containers/misc'
import { Account as AccountForm } from 'components/forms'
import { Input, Checkbox } from 'components/fields'
import { Button, FormDebug } from 'components/misc'
import { apiNextLevel, apiConfiguration } from 'helpers/decorators/api'
import { CONFIGURATION_KEYS, PAYMENT_TYPES } from 'constants/enums'
import getParticipantAge from 'helpers/getParticipantAge'
import config from 'config'

const enhance = compose(
  apiNextLevel(),
  apiConfiguration(),
  wizard({
    form: 'nextLevelRegistration',
    multipage: true,
    destroyOnUnmount: false
  })
)

class Account extends Component {
  static propTypes = {
    reset: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    push: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    createParticipant: PropTypes.func.isRequired,
    nextLevel: PropTypes.object,
    configuration: PropTypes.object,
    location: PropTypes.object.isRequired,
    values: PropTypes.object,
    errors: PropTypes.object
  }

  handleIsAdult = (values, age) =>
    (get(values, 'helpers.price') === PAYMENT_TYPES.online.id ||
      get(values, 'helpers.price') === PAYMENT_TYPES.payPal.id ||
      get(values, 'helpers.price') === PAYMENT_TYPES.globalPayments.id ||
    get(values, 'helpers.price') === PAYMENT_TYPES.globalPaymentsWebpay.id) &&
    age >= getParticipantAge(this.props.configuration)

  handleSubmit = fields => {
    const { nextLevel } = this.props
    const awardFeeAmount = get(nextLevel, 'paymentOptions.amount')
    const awardFeeCurrency = get(nextLevel, 'paymentOptions.currency.value')
    const query = queryString.parse(get(this.props, 'location.search'))
    const authorizationCode = get(query, 'authorizationCode')
    const age = moment().diff(get(fields, 'birthDate'), 'years')

    const isAdultFlow = this.handleIsAdult(fields, age)

    this.props
      .createParticipant(authorizationCode, {
        ...fields,
        awardFeeAmount: Number(awardFeeAmount).toFixed(2),
        awardFeeCurrency
      })
      .then(result => {
        if (isAdultFlow) {
          const authCode = get(
            result,
            'awards[0].participantRegistration.onlinePaymentAuthorizationCode'
          )
          const orgId = get(result, 'awards[0].organization.id')

          this.props.reset()

          if (get(fields, 'helpers.price') === PAYMENT_TYPES.online.id) {
            return this.props.push(`${config.publicPath}/mpg-init/` + authCode)
          }

          if (get(fields, 'helpers.price') === PAYMENT_TYPES.payPal.id) {
            return this.props.push(`${config.publicPath}/paypal-init/` + authCode)
          }

          if (get(fields, 'helpers.price') === PAYMENT_TYPES.globalPayments.id) {
            return this.props.push(`${config.publicPath}/gp-init/` + orgId + '/' + authCode)
          }

          if (get(fields, 'helpers.price') === PAYMENT_TYPES.globalPaymentsWebpay.id) {
            return this.props.push(`${config.publicPath}/gp-wp-init/${authCode}`)
          }
        }

        this.props.onSubmit()
        this.props.reset()
      })
      .catch(err => console.debug(err))
  }

  render() {
    const { handleSubmit, values, errors, nextLevel } = this.props

    const hidePassword = get(values, 'helpers.hidePassword')

    return (
      <form onSubmit={handleSubmit(this.handleSubmit)}>
        {hidePassword &&
          <div className="row">
            <div className="col-xs-6">
              <Input name="email" label="Email" intlKey="email" disabled />
            </div>
          </div>}
        {!hidePassword && <AccountForm values={values} />}

        <ConfigurationFile
          configKey={CONFIGURATION_KEYS.termsAndConditions.id}
          organizationId={get(values, 'organizationId')}
          isPublic
          formattedName={
            <FormattedMessage
              id="button.terms_and_conditions"
              defaultMessage="International Terms & Conditions"
            />
          }
        />

        <div className="row">
          <div className="col-xs-12">
            <Checkbox
              name="helpers.terms"
              label="I have read the <a href='{url}' target='_blank'>Terms and conditions and agree with them."
              intlKey="label.i_have_read_the_terms_and_conditions"
              intlValues={{
                url: '/orb_parental_consent_form.pdf'
              }}
            />
            <Checkbox
              name="helpers.photosConsent"
              label="You can use my photos for promotional purposes. We will always contact you before using your materials. For more information click here."
              intlKey="label.you_can_use_my_photos_for_promotional_purposes"
            />
          </div>
        </div>

        <FormDebug values={values} errors={errors} />

        <Button disabled={get(nextLevel, 'loading')}>
          <FormattedMessage id="button.submit" defaultMessage="Submit" />
        </Button>
      </form>
    )
  }
}

export default enhance(Account)
